// extracted by mini-css-extract-plugin
export default {"root":"PersonBookIcon_root__OtDhb"};